export default __webpack_public_path__ + "assets/ogg/bcf7aca89e8a2f116ea6266d11d4f631.ogg";